// extracted by mini-css-extract-plugin
export default {"reportText":"_3bSfv","reportLink":"_26dto"};